/**
 * The localStorage keys a game session is remembered under, per game name so distinct worlds don't
 * collide. Split out of `useGameSession.ts` so the e2e harness's `signInWithToken` seeds the same
 * keys the app reads, rather than a copy that could drift.
 */

/** localStorage key for a game's remembered reclaim token. */
export function tokenKey(gameName: string): string {
  return `lvtt.game.token:${gameName}`;
}

/** localStorage key for a game's remembered GM host key (so GM-gated REST survives a reconnect). */
export function hostKeyKey(gameName: string): string {
  return `lvtt.game.hostKey:${gameName}`;
}
